import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import TextField from '@mui/material/TextField'
import { useDispatch } from 'react-redux'
import { type FreeResponseQuestion, SurveyItemQuestionType } from '../../../types'
import { addSurveyQuestionInSection, type ISurveySection, setSelectedQuestion, updateBranchFilterPrompt, updateQuestionInSection } from '../../../../../store/slices/SurveyTemplateSlice'
import { getEditableQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { v4 as uuidv4 } from 'uuid'
import { getUniqueChildBranchesDetails } from '../../../helpers'
import Wrapper from './FollowUpWrapper'

interface FollowUpFreeResponseQuestionProps {
  sectionIndex?: number
  questionIndex?: number
  questionNumber?: number
  section: ISurveySection
  isAdminAddedQuestion?: boolean
}

const FollowUpFreeResponseQuestion: React.FC<FollowUpFreeResponseQuestionProps> = ({ sectionIndex = 0, questionIndex = 0, questionNumber, section, isAdminAddedQuestion }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()

  const [freeResponseData, setFreeResponseData] = useState<FreeResponseQuestion>({
    itemId: uuidv4(),
    isRequired: false,
    itemType: SurveyItemQuestionType.FREE_RESPONSE,
    prompt: '',
    branchingFilters: null
  })

  useEffect(() => {
    if (editableQuestion != null && editableQuestion?.question?.itemType === SurveyItemQuestionType.FREE_RESPONSE) {
      setFreeResponseData(editableQuestion.question as FreeResponseQuestion)
    }
  }, [editableQuestion])

  const handleQuestionTitle = (questionTitle: string): void => {
    if (freeResponseData?.branchingFilters) {
      dispatch(updateBranchFilterPrompt({
        childBranches: getUniqueChildBranchesDetails(freeResponseData.branchingFilters),
        prompt: questionTitle
      }))
    }
    setFreeResponseData(prevState => {
      return { ...prevState, prompt: questionTitle }
    })
  }

  const handleClickAway = (): void => {
    if (editableQuestion) {
      dispatch(updateQuestionInSection({ surveySectionId: section.surveySectionId, questionIndex, updatedQuestion: freeResponseData }))
      return
    }

    dispatch(addSurveyQuestionInSection({ surveySectionId: section.surveySectionId, question: freeResponseData }))
    dispatch(setSelectedQuestion(null))
  }

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={handleClickAway}>
      <Box
        sx={
          {
            width: '100%',
            display: 'flex',
            alignContent: 'center'
          }
        }
      >
        <Wrapper isAdminAddedQuestion={isAdminAddedQuestion} questionData={freeResponseData} questionNumber={questionNumber} section={section}>
          <Box>
            <Box sx={
              {
                display: 'flex',
                marginBottom: 5,
                gap: 3.75
              }
            }>
              <TextField sx={
                {
                  flex: 2.5,
                  '& .MuiInputBase-input': {
                    height: 6.5
                  }
                }
              } type='text' value={freeResponseData?.prompt} placeholder='Type your question...' autoFocus onChange={(e) => { handleQuestionTitle(e.target.value) }} />
            </Box>
            <TextField disabled type='text' placeholder='Type your response...' fullWidth />
          </Box>
        </Wrapper>
      </Box>
    </ClickAwayListener>
  )
}

export default FollowUpFreeResponseQuestion
